export const deadp_annual_report = [
  {
    id: 1,
    name: 'MTDP 2024-2029 Final Edit Version - 11 March 2025',
    summary: 'shortsummary/MTDP 2024-2029 Final Edit Version - 11 March 2025.html',
    link: 'MTDP 2024-2029 Final Edit Version - 11 March 2025.pdf',
    audio_en: 'audio/en/MTDP 2024-2029 Final Edit Version - 11 March 2025_en.mp3',
    audio_af: 'audio/af/MTDP 2024-2029 Final Edit Version - 11 March 2025_af.mp3',
    audio_xh: 'audio/xh/MTDP 2024-2029 Final Edit Version - 11 March 2025_xh.mp3'
  },
  {
    id: 2,
    name: 'wced-stratplan-2020-2025',
    summary: 'shortsummary/wced-stratplan-2020-2025.html',
    link: 'wced-stratplan-2020-2025.pdf',
    audio_en: 'audio/en/wced-stratplan-2020-2025_en.mp3',
    audio_af: 'audio/af/wced-stratplan-2020-2025_af.mp3',
    audio_xh: 'audio/xh/wced-stratplan-2020-2025_xh.mp3'
  },
    {
    id: 3,
    name: 'wcg_dea-dp_annual-report_17-september-2025-website',
    summary: 'shortsummary/wcg_dea-dp_annual-report_17-september-2025-website.html',
    link: 'wcg_dea-dp_annual-report_17-september-2025-website.pdf',
    audio_en: 'audio/en/wcg_dea-dp_annual-report_17-september-2025-website_en.mp3',
    audio_af: 'audio/af/wcg_dea-dp_annual-report_17-september-2025-website_af.mp3',
    audio_xh: 'audio/xh/wcg_dea-dp_annual-report_17-september-2025-website_xh.mp3'
  }

];